<script lang="ts">
  import Palette from '@lucide/svelte/icons/palette';

  import { getServices } from '../../app/context';
  import { strings } from '../../strings';
  import Button from '../../ui/Button.svelte';
  import RatingsDialog from '../edit/RatingsDialog.svelte';

  const { store, view } = getServices();
  let customizing = $state(false);
</script>

<!-- Scrolls sideways on small screens, so it must be reachable by keyboard. -->
<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<div
  role="region"
  aria-label={strings.legend}
  tabindex="0"
  class="legend-scroll overflow-x-auto overscroll-x-contain"
>
  <ul
    class="mx-auto flex w-max max-w-[100rem] snap-x items-center gap-x-4 gap-y-1 px-4 py-2 sm:w-auto sm:flex-wrap"
  >
    {#each store.doc.ratings as rating (rating.id)}
      <li class="flex shrink-0 snap-start items-center gap-1.5 text-sm">
        <span
          class="size-4 squircle border border-line"
          style:background-color={rating.color}
          aria-hidden="true"
        ></span>
        {rating.name}
      </li>
    {/each}
    {#if view.editMode}
      <li class="shrink-0">
        <Button size="sm" variant="ghost" onclick={() => (customizing = true)}>
          <Palette size={16} aria-hidden="true" />
          {strings.customizeRatings}
        </Button>
      </li>
    {/if}
  </ul>
</div>

<RatingsDialog bind:open={customizing} />

<style>
  /* Fade the edges on small screens, where the legend scrolls sideways. */
  @media (max-width: 639px) {
    .legend-scroll {
      mask-image: linear-gradient(
        to right,
        transparent,
        #000 1rem,
        #000 calc(100% - 1rem),
        transparent
      );
    }
  }
</style>
